const EXPIRED_CODE = 'VERIFICATION_LINK_EXPIRED'

export const getIsExpiredToken = (code) => {
  if (!code) return false;

  return code === EXPIRED_CODE;
};